/**
 * [Ref] - Denotes Pseudo Code Reference  
 *  
 * This component is the Punchout page component. The component displays the Punchout page details.
 * 
 * App Name: SDI-Walmart
 * Author: Chandrasekar
 * Created Date: 08/17/2020 
 */
import React, { Component } from 'react';
import * as CookieService from '../CookieService';
/**
 * Ref: PO_PC_02
 * Importing the action and store file and set to an object.
 */
import * as PunchoutAction from '../actions/PunchoutAction';
import PunchoutStore from '../stores/PunchoutStore';
import SDIConstants from '../SDIConstants';
import * as $ from 'jquery';
import * as MenuAction from '../actions/MenuAction';
import { withTranslation, Trans } from 'react-i18next'
let currentPagePath;
let serviceURL = "";//await getAPIURL();
//console.log("serviceURL", serviceURL);
class PunchoutComponent extends Component {
    /**
     * Ref: PO_PC_04
     * Define the constructor that takes props as parameter
     * 
     * @param props
     */
    constructor(props) {
        super(props);
        this.assignPunchoutData = this.assignPunchoutData.bind(this);
        this.assingLogoData = this.assingLogoData.bind(this);
        this.loadFavPageResponse = this.loadFavPageResponse.bind(this);
        this.handleFavorite = this.handleFavorite.bind(this);
        this.updateFavPageResponse = this.updateFavPageResponse.bind(this);
        this.logoClick = this.logoClick.bind(this);
        /**
         * Ref: PO_PC_05
         * Set the initial values of the state variables
         */
        this.state = {
            punchoutData: [], errorMessage: "", isFavorited: false, isPageLoaded: false, isError: false, apiURL: "",
        }
    };
    /*
     * To Get API URL from Controller
     */
    setAPIURL = () => {
        let cachedURL = sessionStorage.getItem("serviceURL");
        if (!cachedURL || cachedURL == "") {
            $.ajax({
                type: "GET",
                url: SDIConstants.localService
            }).then((data) => {
                this.setState({ apiURL: data });
                //console.log("ThroughCall", data);
                sessionStorage.setItem("serviceURL", data);
            });

        } else {
            //console.log("ThroughCache", sessionStorage.getItem("serviceURL"));
            this.setState({ apiURL: sessionStorage.getItem("serviceURL") });
        }
    };
    /**
    * Ref: PO_PC_06
    * componentWillMount method will be first method which will be invoked
    * when punchout page is loaded
    */
    componentDidMount() {
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        /**
         * Ref: PO_PC_08
         * Invoke the action to get the page load data from API.
         */
        let pageLoadBO = {
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_USERNAME: CookieService.getLocalStorageValues("Session_USERNAME"),
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            Session_PUNCART: "",
            User_Location: CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "",
            Thirdparty_Comp_id: CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID")
        };
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        PunchoutAction.getCurrentFavPage(getFavPageBO);
        PunchoutAction.getPunchoutSites(pageLoadBO);
        this.setAPIURL();
        /**
         * Ref: PO_PC_07
         * Define the listener methods
         */
        PunchoutStore.on("punchoutData", this.assignPunchoutData);
        PunchoutStore.on("logoData", this.assingLogoData);
        PunchoutStore.on('favpage', this.loadFavPageResponse);
        PunchoutStore.on('updateFavPage', this.updateFavPageResponse);
    };
    componentWillUnmount() {
        PunchoutStore.removeListener("punchoutData", this.assignPunchoutData);
        PunchoutStore.removeListener("logoData", this.assingLogoData);
        PunchoutStore.removeListener('favpage', this.loadFavPageResponse);
        PunchoutStore.removeListener('updateFavPage', this.updateFavPageResponse);
    }
    /**
     * Ref: PO_PC_10
     * Listener method for page load response
     */
    assignPunchoutData = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let punchoutData = JSON.parse(PunchoutStore.punchoutData);
        //console.log("punchoutData", punchoutData);
        this.setState({ punchoutData: punchoutData.PunchoutSites, isPageLoaded: true });
    };
    /**
     * Ref: PO_PC_11
     * Listener method for Logo click action
     */
    assingLogoData = () => {
        //  $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let imageLogoResponse = JSON.parse(PunchoutStore.imageLogoResponse);
        //console.log("imageLogoResponse", imageLogoResponse);
        if (imageLogoResponse.length > 0) {
            CookieService.updateLocalStorageValues("Session_VENDOR_CONFIG", imageLogoResponse[0].Session_VENDOR_CONFIG);
            if (imageLogoResponse[0].RedirectURL) {
                window.location.href = imageLogoResponse[0].RedirectURL;
            } else if (imageLogoResponse[0].lblerror) {
                this.setState({ isError: true });
                /*[04/27/22, WW-389], Priyanka D */
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
            }
        }
    };
    /**
     * Ref: PO_PC_09
     * This method will be invoked on click of Punchout vendor logo
     */
    logoClick = (event, VendorID) => {
        event.preventDefault();
        /*[04/27/22, WW-389], Priyanka D */
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let logoBO = {
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_USERNAME: CookieService.getLocalStorageValues("Session_USERNAME"),
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            Session_PUNCART: "",
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_IOLServer: CookieService.getLocalStorageValues("Session_IOLServer"),
            vendorID: VendorID,
            Session_email: CookieService.getLocalStorageValues("Session_EMAIL"),
            Session_CUSTID: CookieService.getLocalStorageValues("Session_CUSTID"),
            Session_CONAME: CookieService.getLocalStorageValues("Session_CONAME"),
            Session_cplusServer: CookieService.getLocalStorageValues("Session_cplusServer"),
        };
        PunchoutAction.punchoutLogoClick(logoBO);

    };
    /**
     * Ref: PO_PC_13
     * This method will be invoked on render for binding punchout data
     */
    bindPunchoutSites = () => {
        
        /*[01/06/22, PC_SC_24,WW-283], Priyanka D//Remove Lowe's punchout for PRI users*/
        let location = "";
        if (CookieService.getLocalStorageValues("homestoreloc") != null && CookieService.getLocalStorageValues("homestoreloc") != undefined && CookieService.getLocalStorageValues("homestoreloc") != "" && CookieService.getLocalStorageValues("homestoreloc") != " ") {
            location = CookieService.getLocalStorageValues("homestoreloc");
        } else if (CookieService.getLocalStorageValues("Session_STATE") != null && CookieService.getLocalStorageValues("Session_STATE") != undefined && CookieService.getLocalStorageValues("Session_STATE") != "" && CookieService.getLocalStorageValues("Session_STATE") != " ") {
            location = CookieService.getLocalStorageValues("Session_STATE");
        }
        let punchoutData = [];
        if (location == "PRI" || location == "PR") {
            punchoutData = this.state.punchoutData.filter((x) => x.VENDOR_ID != "W000000091")
        } else {
            punchoutData = this.state.punchoutData;
        }
        return punchoutData.map((site, index) => {
            let imageLogo = "";
            if (site.LOGOIMAGE != undefined && site.LOGOIMAGE != null) {
                if (site.LOGOIMAGE.includes("http")) {
                    imageLogo = site.LOGOIMAGE.replace(":8083", "");;
                }
                else {
                    imageLogo = site.LOGOIMAGE ? this.state.apiURL + site.LOGOIMAGE : "";
                }
            }

            return (<a href="#" key={index} className="col-6 col-sm-4 col-lg-3 float-left vendor-container mb-3" onClick={(e) => this.logoClick(e, site.VENDOR_ID)}>
                <div className="col-md-12 vendorlogo-container" >
                    <img src={imageLogo} onerror="/Images/noimage_new.png" className="pounchout-logo" alt={site.PUNCHOUT_NAME} />
                </div>
            </a>);
        })
    };
    /**
    * Listener method for the response of Save/Delete favorite page
    */
    updateFavPageResponse = () => {
        if (PunchoutStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(PunchoutStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(PunchoutStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
    };
    /**
    * Handle change method for favorite page checkbox
    * @param event
    */
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Punchout Catalog",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            PunchoutAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            PunchoutAction.deleteFavPage(deleteFavPageBO)
        }
    };
    /**
    * Listener method for loading favorite page icon
    */
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(PunchoutStore.currentFavPageResponse);
        //console.log("favPageResponse", favPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };

    render() {
        return (
            <div className="container-fluid content-section">
                <div className="row">
                    {this.state.punchoutData.length > 0 ? (<div className="container-fluid content-margin">
                        <div className="row justify justify-content-center mx-0">
                            <div className="col-md-12 page-heading mb-3">
                                <h5 className="page-title"><Trans>Punchout Catalog</Trans></h5>
                                <div className="fav-item-maintenance-icon mt-1">
                                    <input type="checkbox" id="checkbox-1" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                    <label htmlFor="checkbox-1">
                                        <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                            <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                <g className="grp7" opacity={0} transform="translate(7 6)">
                                                    <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                    <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                </g>
                                                <g className="grp6" opacity={0} transform="translate(0 28)">
                                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                    <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                </g>
                                                <g className="grp3" opacity={0} transform="translate(52 28)">
                                                    <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                    <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                </g>
                                                <g className="grp2" opacity={0} transform="translate(44 6)">
                                                    <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp5" opacity={0} transform="translate(14 50)">
                                                    <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                    <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp4" opacity={0} transform="translate(35 50)">
                                                    <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                    <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp1" opacity={0} transform="translate(24)">
                                                    <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                    <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                </g>
                                            </g>
                                        </svg>
                                    </label>
                                </div>
                            </div>
                            {this.state.isError == false ? (<div className="col-md-8 mx-auto my-5" id="punchoutContent1">
                                {this.bindPunchoutSites()}

                            </div>) :
                                (<div className="col-md-7 float-left" id="punchoutContent2">
                                    <p className="error-mg-txt text-center"><span>*** </span><Trans>ERROR</Trans><span> ***</span></p>
                                    <br />
                                    <br />
                                    <p className="error-txt-msg text-center"><Trans>PunchOut is not currently available for this Vendor.</Trans><br /><br /><Trans>A message was sent notifying site administrator of this problem.</Trans><br /><br /><Trans>We apologize for this inconvenience.</Trans></p>
                                    <div className="text-center my-5 ">
                                        <button className="btn btn-primary custom-btn-primary primary-btn secondaryinfo" onClick={() => this.props.history.push({
                                            pathname: '/homepage',
                                        })}><Trans>Return</Trans></button>
                                    </div>
                                </div>)}
                        </div>
                    </div>) :
                        this.state.isPageLoaded == true ? (<section className="site-undercontruction container text-center center-panel">
                            <p className="primaryinfo"><Trans>No Vendor available</Trans></p>
                            <p className="secondaryinfo"><Trans>There is no vendors available</Trans></p>
                            <div className="img-section">
                                <img src="images/no_vendor.jpg" alt="imagefile" />
                            </div>
                            <div className="text-center my-3">
                                <button className="btn btn-primary custom-btn-primary primary-btn secondaryinfo" onClick={() => this.props.history.push({
                                    pathname: '/homepage',
                                })}><Trans>Back to Home</Trans></button>
                            </div>
                        </section>) : null}
                </div>
            </div>);

    };
}
export default withTranslation()(PunchoutComponent);